import { UserFollowedDataObjectGroupValidFormDataSchema } from './UserFollowedDataObjectGroupValidFormDataSchema';
import {
  UserFollowedDataObjectGroupFormDataType,
  UserFollowedDataObjectGroupMutationDtoType,
  UserFollowedDataObjectGroupValidFormDataType,
} from './types';
import { UserFollowedDataObjectGroupMutationDtoSchema } from './UserFollowedDataObjectGroupMutationDtoSchema';
import { UserFollowedDataObjectGroupFormDataSchema } from './UserFollowedDataObjectGroupFormDataSchema';

export class UserFollowedDataObjectGroupSchema {
  static parseFormData<Dto>(
    data: Dto
  ): UserFollowedDataObjectGroupFormDataType {
    return UserFollowedDataObjectGroupFormDataSchema.parse(data);
  }

  static parseMutationDto<
    ValidFormData extends Partial<UserFollowedDataObjectGroupValidFormDataType>
  >(validFormData: ValidFormData): UserFollowedDataObjectGroupMutationDtoType {
    return UserFollowedDataObjectGroupMutationDtoSchema.parse(validFormData);
  }

  static validFormDataSchema = UserFollowedDataObjectGroupValidFormDataSchema;
}
